var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.activo.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstado,
                                  readonly: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.activo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.activo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.activo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.modoVer && "required",
                                    expression: "!modoVer && 'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.proveedorGps.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.proveedorGps.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.proveedorGps.id,
                                  items: _vm.formFields.proveedorGps.items,
                                  disabled: _vm.modoVer || _vm.modoEditar,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  "no-data-text": "Datos no disponibles"
                                },
                                model: {
                                  value: _vm.formFields.proveedorGps.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.proveedorGps,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.proveedorGps.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.modoVer && "required",
                                    expression: "!modoVer && 'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.contratos.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.contratos.id
                                  ),
                                  "data-vv-name": _vm.formFields.contratos.id,
                                  items: _vm.formFields.contratos.items,
                                  disabled: _vm.modoVer || _vm.modoEditar,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  "no-data-text": "Datos no disponibles"
                                },
                                model: {
                                  value: _vm.formFields.contratos.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.contratos,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.contratos.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md12: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.modoVer && "required",
                                    expression: "!modoVer && 'required'"
                                  }
                                ],
                                attrs: {
                                  label:
                                    _vm.formFields.clienteProveedorGps.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.clienteProveedorGps.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.clienteProveedorGps.id,
                                  items:
                                    _vm.formFields.clienteProveedorGps.items,
                                  disabled: _vm.modoVer || _vm.modoEditar,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  "no-data-text": "Datos no disponibles"
                                },
                                model: {
                                  value:
                                    _vm.formFields.clienteProveedorGps.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.clienteProveedorGps,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.clienteProveedorGps.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.modoVer && "required",
                                    expression: "!modoVer && 'required'"
                                  }
                                ],
                                ref: "fechaInicio",
                                attrs: {
                                  label: _vm.formFields.fechaInicio.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaInicio.id
                                  ),
                                  id: _vm.formFields.fechaInicio.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.fechaInicio.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaInicio,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaInicio.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("TimePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.modoVer && "required",
                                    expression: "!modoVer && 'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.horaInicio.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.horaInicio.id
                                  ),
                                  id: _vm.formFields.horaInicio.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.horaInicio.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.horaInicio,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.horaInicio.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("DatePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.modoVer &&
                                      _vm.formFields.horaTermino.value &&
                                      "required|fechaTerminoMayor:fechaInicio",
                                    expression:
                                      "\n                  !modoVer &&\n                    formFields.horaTermino.value &&\n                    'required|fechaTerminoMayor:fechaInicio'\n                "
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.fechaTermino.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaTermino.id
                                  ),
                                  id: _vm.formFields.fechaTermino.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.fechaTermino.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaTermino,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaTermino.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("TimePicker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      !_vm.modoVer &&
                                      _vm.formFields.fechaTermino.value &&
                                      "required",
                                    expression:
                                      "\n                  !modoVer && formFields.fechaTermino.value && 'required'\n                "
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.horaTermino.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.horaTermino.id
                                  ),
                                  id: _vm.formFields.horaTermino.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.horaTermino.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.horaTermino,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.horaTermino.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.modoVer,
                                    expression: "!modoVer"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.endpoint.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.endpoint.id
                                  ),
                                  "data-vv-name": _vm.formFields.endpoint.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.endpoint.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.endpoint,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.endpoint.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.modoVer && "max:50",
                                    expression: "!modoVer && 'max:50'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.login.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.login.id
                                  ),
                                  "data-vv-name": _vm.formFields.login.id,
                                  disabled: _vm.modoVer,
                                  counter: "50"
                                },
                                model: {
                                  value: _vm.formFields.login.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.login, "value", $$v)
                                  },
                                  expression: "formFields.login.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("CampoContrasena", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !_vm.modoVer && "max:50",
                                    expression: "!modoVer && 'max:50'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.password.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.password.id
                                  ),
                                  "data-vv-name": _vm.formFields.password.id,
                                  disabled: _vm.modoVer,
                                  counter: "50"
                                },
                                model: {
                                  value: _vm.formFields.password.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.password,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.password.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.apiKey.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.apiKey.id
                                  ),
                                  "data-vv-name": _vm.formFields.apiKey.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.apiKey.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.apiKey,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.apiKey.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }